export const CATEGORY_ORDER = [
  'account_auth',
  'notification_push',
  'content_social',
  'celeb_engagement',
  'safety_moderation',
  'discovery_location',
  'reward_game',
  'release_operations',
];

export const SYNC_STATUSES = ['aligned', 'layered', 'frontend_only', 'backend_only', 'mismatch', 'runtime'];
export const VERIFICATION_STATUSES = ['verified', 'drift', 'stale', 'failed', 'manual_review'];

export function policyForEnvironment(value, environment, environmentValues) {
  if (environmentValues?.[environment]) return environmentValues[environment];
  const selectedIndex = environment === 'test' ? 2 : 1;
  return String(value || '').replace(
    /PROD\s+([^/,;]+)\s*\/\s*TEST\s+([^,;]+)/g,
    (_match, prodValue, testValue) => (selectedIndex === 1 ? prodValue : testValue).trim(),
  );
}

export function uniqueValues(entries, field) {
  return [...new Set(entries.flatMap((entry) => entry[field] || []))].sort();
}

export function filterPolicyEntries(entries, filters) {
  const query = filters.query.trim().toLocaleLowerCase();
  return entries.filter((entry) => {
    if (entry.visibility === 'excluded') return false;
    if (!filters.includeDetail && entry.visibility === 'detail') return false;
    if (filters.category !== 'all' && entry.category !== filters.category) return false;
    if (filters.enforcement !== 'all' && !entry.enforcement.includes(filters.enforcement)) return false;
    if (filters.impact !== 'all' && !entry.impacts.includes(filters.impact)) return false;
    if (filters.syncStatus !== 'all' && entry.sync.status !== filters.syncStatus) return false;
    if (filters.verificationStatus !== 'all' && entry.verification?.status !== filters.verificationStatus) return false;
    if (!query) return true;
    return [
      entry.name,
      entry.current_policy,
      ...Object.values(entry.environment_values || {}),
      entry.applies_when,
      entry.outcome,
      entry.id,
      ...entry.enforcement,
      ...entry.impacts,
    ].some((value) => String(value).toLocaleLowerCase().includes(query));
  });
}
